import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { ForgeButtonModule } from "@tylertech/forge-angular";

export interface ConfirmDialogData
{
    readonly title?: string;
    readonly message: string;
    readonly okLabel?: string;
    readonly cancelLabel?: string;
}

@Component({
    selector: "confirm-dialog",
    templateUrl: "./confirm.tmpl.html",
    imports: [
        CdkScrollable,
        ForgeButtonModule,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
    ]
})
export class ConfirmDialogComponent
{
    private readonly dialogRef = inject<MatDialogRef<ConfirmDialogComponent, boolean>>(MatDialogRef);
    private readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);


    get title(): string { return this.data.title ?? "Confirm"; }
    get message(): string { return this.data.message; }
    get okLabel(): string { return this.data.okLabel ?? "Yes"; }
    get cancelLabel(): string { return this.data.cancelLabel ?? "No"; }

    accept(): void
    {
        this.dialogRef.close(true);
    }

    cancel(): void
    {
        this.dialogRef.close(false);
    }
}
